<script setup>
import { useField } from 'vee-validate'

// Definição de propriedades
const props = defineProps({
  name: {
    type: String,
    required: true,
  },
  label: {
    type: String,
    required: false,
  },
  labelPosition: {
    type: String,
    default: 'right',
    validator: val => ['left', 'right'].includes(val),
  },
  size: {
    type: String,
    default: 'size-[16px]',
  },
  modelValue: {
    type: Boolean,
    default: false,
  },
})

const { value, errorMessage } = useField(() => props.name, undefined, {
  syncVModel: true,
  initialValue: props.modelValue,
})
</script>

<template>
  <div>
    <div
      class="flex items-center gap-2"
      :class="{
        'flex-row': labelPosition === 'right',
        'flex-row-reverse': labelPosition === 'left',
      }"
    >
      <!-- Checkbox -->
      <input
        type="checkbox"
        v-model="value"
        :id="name"
        class="form-checkbox border-primary-90 text-secondary-50 focus:ring-secondary-60 disabled:bg-neutral-30 disabled:checked:bg-primary-90/50 disabled:checked:hover:bg-primary-90/50 cursor-pointer rounded-md disabled:cursor-default disabled:border-none"
        :class="size"
        v-bind="$attrs"
      />
      <!-- Label: use prop label or named slot 'label' inside the <label> so clicking toggles the input -->
      <label v-if="label || $slots.label" class="text-primary-90 w-full text-sm" :for="name">
        <template v-if="label">{{ label }}</template>
        <template v-else><slot name="label" /></template>
      </label>
    </div>
    <!-- Mensagem de erro -->
    <span v-if="errorMessage" class="text-error-60 mt-0 pt-0 text-xs">
      {{ errorMessage }}
    </span>
  </div>
</template>
